/* eslint-disable no-bitwise */
/* eslint-disable prefer-template */

function stringToHash(input) {
  let hash1 = 0x811c9dc5;
  let hash2 = 0x1000193;
  let hash3 = 0x27d4eb2d;

  for (let i = 0; i < input.length; i++) {
    const char = input.charCodeAt(i);
    hash1 ^= char;
    hash1 = (hash1 * 0x01000193) >>> 0;

    hash2 += char;
    hash2 = (hash2 * 0x27d4eb2d) >>> 0;

    hash3 ^= (char + hash2);
    hash3 = (hash3 * 0x85ebca6b) >>> 0;
  }
  // 合并多个哈希值
  const combined = ((hash1 << 16) ^ hash2 ^ hash3) >>> 0;
  return combined.toString(16);
}

function stringToUUID(str) {
  // 生成基础哈希
  const baseHash = stringToHash(str);

  // 生成多个哈希变体以获得足够的字符
  const hashVariants = [
    stringToHash(str + '1'),
    stringToHash(str + '2'),
    stringToHash(str + '3'),
    stringToHash(str + '4'),
    stringToHash(str + '5'),
    stringToHash(str + '6'),
  ];

  // 合并所有哈希值
  let combinedHash = baseHash;
  hashVariants.forEach((variant) => {
    combinedHash += variant;
  });

  // 移除所有非十六进制字符，确保只有0-9a-f
  combinedHash = combinedHash.replace(/[^a-f0-9]/g, '');

  // 如果不够长，重复填充
  while (combinedHash.length < 53) {
    combinedHash += combinedHash;
  }

  // 截取到所需长度
  combinedHash = combinedHash.substr(0, 53);

  // 格式: xxxxxxxxxxxxx-xxxxxxxxxxxxxx-xxxxxxxx-xxxxx-xxxxxxxxxxxxx
  const part1 = combinedHash.substr(0, 13); // 13个字符
  const part2 = combinedHash.substr(13, 14); // 14个字符
  const part3 = combinedHash.substr(27, 8); // 8个字符
  const part4 = combinedHash.substr(35, 5); // 5个字符
  const part5 = combinedHash.substr(40, 13); // 13个字符

  return `${part1}-${part2}-${part3}-${part4}-${part5}`;
}

export {
  stringToHash,
  stringToUUID,
};
